<br>
Denna vy används för att uppdatera och räkna om en medlems medlemsavgifter.<br>
<br>
<br>
<div style="border:1px solid lightgrey;border-radius:10px;padding:10px;width:800px;">
  <form [formGroup]="form">
    <div class="d-flex justify-content-align gap-3">
      <div class="form-group">
        <label for="memberId">
          Medlemsid
        </label>
        <input type="text" class="form-control form-control-sm" id="memberId" style="max-width:120px;" formControlName="memberId" (change)="getMemberInfo()">
      </div>
      <div class="form-group d-flex justify-content-align gap-3">
         <label>&nbsp;</label>
        <label>&nbsp;</label>
        <button class="btn border" [disabled]="!form.get('memberId')?.value" (click)="confirmRemoveMember()">Uppdatera medlemsavgifter</button>
        <div style="border:2px solid lightgrey;margin-left:4px;margin-right:4px;height:100%;"></div>
        
        <button class="btn border" [disabled]="!form.get('institutionId')?.value" (click)="confirmRecalculateAllMemberFees()">Räkna om alla medlemsavgifter för vald institution</button>
      </div>

    <div class="form-group">
        <label for="memberId">
          Institutionsid
        </label>
        <input type="text" class="form-control form-control-sm" id="institutionId" style="max-width:120px;" formControlName="institutionId">
      </div>


      <app-fee-help class="d-flex align-items-center"></app-fee-help>
    </div>
   
    <br>
    <div *ngIf="member">
      <div class="row">
        <div *ngIf="imageToShow !== null" class="col-md-3">
          <img src='{{imageToShow}}' width="100px" style="margin-top:1px;border-radius:10px;">
        </div>
        <div *ngIf="imageToShow === null" class="col-md-3">
          <div width="100px" style="margin-top:1px;border-radius:10px;height:150px;font-size:10px;border:1px solid lightgrey;text-align:center;">
            FOTO SAKNAS
          </div>
        </div>
        <div class="col-md-8 ms-3">
          {{member.givenName}} {{member.familyName}} <br>
          {{member.birthday|date:'yyyy-MM-dd'}} <br>
          {{member.homeAddress?.city}} <br>
          <b>{{primaryinstitution?.shortName}} - {{primaryinstitution?.name}}</b>
        </div>
      </div>
    </div>
    <br>
  </form>
</div>
<div *ngIf="!member && message">
  <span class="py-2 mt-4 badge badge-info" style="font-size:14px;">{{message}}</span>
</div>